import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as logoutAction from '../action/logoutAction';
import * as myProfileAction from '../action/myProfileAction';
//Material-ui
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import Checkbox from '@material-ui/core/Checkbox';
//Part
import PartPageTitle from './PartPageTitle';

class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      autoLoginDelVisible: false,
      autoLoginDel: false,
    }
  }

  componentDidMount() {
    this.props.myProfileGet();
  }

  _logoutSubmit() {
    this.props.logout(this.state.autoLoginDel);
  }

  render() {
    return (
      <div>
        <PartPageTitle
          title='ログアウト'
          onback={ '/' }
        />
        <div style={{maxWidth:'400px', margin:'auto'}}>
          <div style={{margin:'10px'}}>
            <Box style={{background:'#FFF'}} className='round12' boxShadow={2}>
              <div style={{padding:'10px'}}>
                <div align='center' style={{margin:'10px'}}>
                  <span className='i-b'>共用の端末ではない場合</span>
                  <span className='i-b'>ログアウトは必要ありません</span>
                  <span className='i-b'>会員ページを操作しなければ</span>
                  <span className='i-b'>自動的にログアウトします</span>
                </div>


                <div align='center'>
                  <Button
                    variant="contained"
                    color='primary'
                    onClick={ () => this._logoutSubmit() }
                  >
          				  ログアウトする
                  </Button>
                </div>

                <div align='center' style={{margin:'10px'}}>
                  <div
                    onClick={ () => this.setState({autoLoginDelVisible: true}) }
                  >
                    <u style={{cursor:'pointer'}}>共用端末でログアウトが必要な場合</u>
                  </div>
                </div>
                <Collapse in={this.state.autoLoginDelVisible}>
                  <div align='center' style={{padding:'10px'}}>
                    <span className='i-b'>次回ログインする際に</span>
                    <span className='i-b'>必要なログインID</span>
                    <span className='i-b'>大切に保管してください</span>
                    <div style={{fontSize:'1.2em'}} >{this.props.my.setting.loginId}</div>
                  </div>

                  <div align='center' style={{padding:'10px'}}>
                    <Checkbox
                      checked={this.state.autoLoginDel}
                      onChange={ (e) => this.setState({autoLoginDel: e.target.checked})}
                    />
                    次回自動ログインを利用しない
                  </div>

                  <div align='center' style={{margin:'10px'}}>
                    <Button
                      variant="contained"
                      color='secondary'
                      onClick={ () => this._logoutSubmit() }
                    >
            				  ログアウトする
                    </Button>
                  </div>
                </Collapse>
              </div>
            </Box>
          </div>
        </div>

      </div>
    )
  }
}

const mapStateToProps = (state) => {
	return {
		my: state.my,
	}
};
const mapDispatchToProps = dispatch => (
	bindActionCreators({
    ...logoutAction,
    ...myProfileAction,
	}, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
